'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { earnStatisticsBunja, earnSummaryBunja, isEarnCardCurrency } from '@flipster/features/src/shared/earn/state';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import { convertDate } from '@flipster/utils/datetime';

import { ActiveAprCard } from './active-apr-card';
import { LatestUpdate } from './latest-update';

export const YourEarnAprSection = () => {
  const { earnSummaryAtom } = useBunja(earnSummaryBunja);
  const { earnStatisticsAtom } = useBunja(earnStatisticsBunja);

  const earnSummary = useAtomValue(earnSummaryAtom);
  const earnStatistics = useAtomValue(earnStatisticsAtom);

  const latestUpdate = convertDate(earnStatistics?.aprUpdatedAt);

  return (
    <section className={stack({ gap: 20 })}>
      <div className={css({ textStyle: 'Title/M', color: 'content.default.level-5' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Your_earnings' />
      </div>
      <div className={stack({ gap: 10 })}>
        {earnSummary?.currencies
          .filter((c) => isEarnCardCurrency(c.currency))
          .map((c) => <ActiveAprCard key={c.currency} currency={c.currency} />)}
      </div>
      <LatestUpdate date={latestUpdate} />
    </section>
  );
};

export default YourEarnAprSection;
